import React, { FunctionComponent } from 'react';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';

export const Placeholder: FunctionComponent<any> = () => (
  <BreadcrumbComponent />
);

export default Placeholder;
